const externalData = require( './data.json' );

const getMunicipalities = () => {
	let municipalitiesArray = Object.values( externalData.municipalities );
	/*return municipalitiesArray.map(municipality => {
		return {
			id: municipality.id,
			name: municipality.name_fi
		}
	});*/
	return municipalitiesArray;
};

const getSpendingCategories = () => {
	return Object.values( externalData.spending_categories );
};

const getNeighbors = () => {
	return externalData.neighbors;
};

const formatNr = ( x, addComma ) => {
	x = x.toString().replace( /\B(?=(\d{3})+(?!\d))/g, ' ' );
	x = x.replace( '.', ',' );
	if ( addComma === true && x.indexOf( ',' ) === -1 ) {
		x = x + ',0';
	}
	return x === '' ? 0 : x;
};

const roundNr = ( x, d ) => {
	console.log( 'x,d', x, d );
	return parseFloat( x.toFixed( d ) );
};

const createMarkup = ( arrayObject ) => {
	return { __html: arrayObject.join( '' ) };
};

const getThreeDigitId = ( id ) => {
	if ( id < 10 ) {
		return '00' + id;
	} else if ( id < 100 ) {
		return '0' + id;
	}
	
	return id;
};

const setPath = () => {
	// Ilu: should use window.location
	/*if ( window.location.href.match( 'dev' ) ) {
		/!*plusApp.path = 'http://dev.yle.fi/2017/' + plusApp.projectName + '/public/';*!/
		plusApp.path = '';
	} else if ( location.href.match( 'svenska.yle.fi' ) ) {
		plusApp.path = '//svenska.yle.fi/dataviz/2017/' + plusApp.projectName + '/';
	} else if ( location.href.match( 'yle.fi/plus' ) ) {
		plusApp.path = '//yle.fi/plus/yle/2017/' + plusApp.projectName + '/';
	} else {
		plusApp.path = './';
	}*/
};


const capitalizeFirstLetter = ( string ) => {
	return string.charAt( 0 ).toUpperCase() + string.slice( 1 ).toLowerCase();
};

export {
	getMunicipalities,
	getSpendingCategories,
	getNeighbors,
	getThreeDigitId,
	formatNr,
	roundNr,
	createMarkup,
	capitalizeFirstLetter,
	setPath
};
